<template lang="html">
  <div>
    <toolbar class="Home__PageTeller"
      :title="pageName"
      v-on:TOGGLE_SIDEBAR="toggleSidenav"></toolbar>
      
    <mediaItemUploading :style="{ opacity: videoUploadingComponentOpacity}" v-on:showVideoUploading="showMediaItemUploadingComponent"/>

    <transition name="slide-fade" mode="out-in">
      <router-view class="layout-content"></router-view>
    </transition>

  </div>
</template>

<script>
  //import Sidebar from '../shared-components/Sidebar';
  import Toolbar from '../shared-components/Toolbar';
  import mediaItemUploading from './mediaItem/MediaItemUploading.vue';

  export default {
    name: 'Home',
    data() {
      return {
        videoUploadingComponentOpacity: 0
      };
    },
    components: {
      //Sidebar,
      Toolbar,
      mediaItemUploading
    },
    computed: {
      pageName() {
        return this.$route.name;
      }
    },
      created () {
        window.addEventListener('beforeunload', this.beforeWindowUnload)
      },
      beforeDestroy () {
        window.removeEventListener('beforeunload', this.beforeWindowUnload)
      },
    methods: {
      toggleSidenav() {
        this.$refs.sidenav.toggle();
      },
      showMediaItemUploadingComponent(show){
        if (show) {
          this.videoUploadingComponentOpacity = 1
        } else {
          this.videoUploadingComponentOpacity = 0
        }
      },
      //delete unfinished uploads from localstorage if user leaves the page
      beforeWindowUnload (e) {
        const keys = Object.keys(localStorage);
        const uploadVideoKeys = keys.filter(key => key.startsWith('videoupload'));
        const hasUnfinishedUploads = uploadVideoKeys.some(key => {
          const value = localStorage.getItem(key);
          return value !== '100';
        });
        if (hasUnfinishedUploads) {
          e.preventDefault();
          setTimeout(() => {
            uploadVideoKeys.forEach(key => {
              const value = localStorage.getItem(key);
              if(value !== '100'){
                localStorage.removeItem(key);
              }
            });
          }, 100);
        }
      },
      beforeRouteLeave (to, from, next) {
        window.location = to.path
      }
    }
  };
</script>

<style lang="scss" scoped>
  .layout-content {
    padding-top: 72px;
  }
  .Home__PageTeller {
    position: fixed;
    width: 100%;
    z-index: 2;
    .md-title {
      text-transform: capitalize;
    }
  }
</style>



// WEBPACK FOOTER //
// src/spa/Home.vue